import Vue from 'vue';
import VueRouter from 'vue-router';
import CloudManager from '../views/CloudManager.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'manager',
    component: CloudManager
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
